import React, { Component } from "react";
import './simplefooterDois.css'
export default class Simplefooter extends Component {
  render() {
    return (
      <div class="bottomSide-simpleFooter" id="containerFooter">
        <div className="copyright-paragraph-simpleFooter" id="tituloFooter">
          <p>
            HIT-BRA LTDA. | TREINAMENTOS E CERTIFICAÇÕES
          </p>
        </div>
        <div className="redes-sociais-simpleFooter" id="redesFooter">
          <a
            href="https://www.linkedin.com/company/hitbra/"
            rel="noopener noreferrer"
            target="_blank"
            className="sociais"
            title="Linkedin"
          >
            <i className="fa fa-linkedin-square icon-simpleFooter"></i>
          </a>
          <a
            href="https://www.facebook.com/Hit-bra-281725012753310/"
            rel="noopener noreferrer"
            target="_blank"
            className="sociais"
            title="Facebook"
          >
            <i className="fa fa-facebook-square icon-simpleFooter"></i>
          </a>
          <a
            href="https://twitter.com/HitBra"
            rel="noopener noreferrer"
            target="_blank"
            className="sociais"
            title="Twitter"
          >
            <i className="fa fa-twitter-square icon-simpleFooter"></i>
          </a>
          <a
            href="https://www.instagram.com/hitbra/"
            rel="noopener noreferrer"
            target="_blank"
            className="sociais"
            title="Instagram"
          >
            <i className="fa fa-instagram icon-simpleFooter"></i>
          </a>
          <a
            href="https://www.youtube.com/channel/UCskc38hRobYDyMLzKou6fsQ?view_as=subscriber"
            rel="noopener noreferrer"
            target="_blank"
            className="sociais"
            title="YouTube"
          >
            <i className="fa fa-youtube-square icon-simpleFooter"></i>
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/simplefooter.js